<template>
  <div class="home" v-loading="loading">
    <MapComponent
      :bgImg="'/images/bg.svg'"
      :mapData="mapDataId"
      :onLoadBool="onLoadBool"
      @initAudio="initAudio"
    />
    <!-- loading字体 -->
    <div class="loadStyle" v-if="loading">场景加载中...</div>
    <!-- safari浏览器提示 -->
    <!-- <div class="stopPos" v-if="isSafari"> -->
    <stopSafariCom-component v-if="isSafari"></stopSafariCom-component>
    <!-- </div> -->
  </div>
</template>

<script>
var diff_x_val = 504;
// @ is an alias to /src
import MapComponent from "../components/MapComponent.vue";
import StopSafariCom from "../components/StopSafariCom.vue";
import { mapState, mapMutations } from "vuex";

var audioUrl =
  "https://wanos-go-1306012690.cos.ap-beijing.myqcloud.com/space/audio/aac/";
var audioUrl_more =
  "https://wanos-go-1306012690.cos.ap-beijing.myqcloud.com/space/audio/aac1017/";

export default {
  name: "Home",
  components: {
    MapComponent,
    "stopSafariCom-component": StopSafariCom,
  },
  data() {
    return {
      loading: true,
      mapData: [
        {
          src: "/space/images/Group 2931.png",
          top: 570,
          left: 2070 + diff_x_val,
        },
        {
          src: "/space/images/Group 2932.png",
          top: 180,
          left: 1020 + diff_x_val,
        },
        {
          src: "/space/images/Group 2933.png",
          top: 800,
          left: 400 + diff_x_val,
        },
        {
          src: "/space/images/propeller.png",
          left: 9999,
          top: 9999,
        },
        //鼓点
        {
          src: "/space/images/sound-source.svg",
          audioSrc: audioUrl + "drum.aac",
          left: 2050,
          top: 1000,
          type: 2,
          height: 0,
          sceneType: 0,
          xhrStep: 1,
        },
        // 男女对话
        {
          audioSrc: audioUrl + "speak/DIA_Boy_01.C.aac",
          left: 824 + diff_x_val,
          top: 695,
          type: 3,
          sceneType: 2,
          xhrStep: 3,
          height: 0,
        },
        {
          audioSrc: audioUrl + "speak/DIA_Girl_01.C.aac",
          left: 986 + diff_x_val,
          top: 546,
          type: 3,
          sceneType: 2,
          xhrStep: 3,
          height: 0,
        },
        // '''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''
        // 爵士乐
        // 爵士乐_1
        {
          audioSrc: audioUrl_more + "04_01.aac",
          left: 2144 - 70 + diff_x_val,
          top: 1315,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_2
        {
          audioSrc: audioUrl_more + "04_02.aac",
          left: 2357 - 70 + diff_x_val,
          top: 1317,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_3
        {
          audioSrc: audioUrl_more + "04_03.aac",
          left: 2246 - 70 + diff_x_val,
          top: 1276,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_4
        {
          audioSrc: audioUrl_more + "04_04.aac",
          left: 2248 - 70 + diff_x_val,
          top: 1428,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_5
        {
          audioSrc: audioUrl_more + "04_05.aac",
          left: 2091 - 70 + diff_x_val,
          top: 1425,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_6
        {
          audioSrc: audioUrl_more + "04_06.aac",
          left: 2402 - 70 + diff_x_val,
          top: 1428,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_7
        {
          audioSrc: audioUrl_more + "04_07.aac",
          left: 2160 - 70 + diff_x_val,
          top: 1562,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_8
        {
          audioSrc: audioUrl_more + "04_08.aac",
          left: 2313 - 70 + diff_x_val,
          top: 1576,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
        },
        // 爵士乐_9
        {
          audioSrc: audioUrl_more + "04_09.aac",
          left: 2184 - 70 + diff_x_val,
          top: 1370,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
          height: 2,
        },
        // 爵士乐_10
        {
          audioSrc: audioUrl_more + "04_10.aac",
          left: 2312 - 70 + diff_x_val,
          top: 1370,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
          height: 2,
        },
        // 爵士乐_11
        {
          audioSrc: audioUrl_more + "04_11.aac",
          left: 2184 - 70 + diff_x_val,
          top: 1486,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
          height: 2,
        },
        // 爵士乐_12
        {
          audioSrc: audioUrl_more + "04_12.aac",
          left: 2312 - 70 + diff_x_val,
          top: 1486,
          type: 3,
          sceneType: 3,
          xhrStep: 4,
          height: 2,
        },
        // 海边-------------------------------------------------------
        // 海边_1
        {
          audioSrc: audioUrl_more + "03_01.aac",
          left: 3169 + diff_x_val,
          top: 425,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_2

        {
          audioSrc: audioUrl_more + "03_02.aac",
          left: 2790 + diff_x_val,
          top: 1132,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_3
        {
          audioSrc: audioUrl_more + "03_03.aac",
          left: 2534 + diff_x_val,
          top: 234,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_4
        {
          audioSrc: audioUrl_more + "03_04.aac",
          left: 3071 + diff_x_val,
          top: 1634,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_4_T
        {
          audioSrc: audioUrl_more + "03_04T.aac",
          left: 3071 + diff_x_val,
          top: 1634,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },

        // 原方案
        // 海边_水声_-1
        {
          audioSrc: audioUrl + "sea/sea_2.aac",
          left: 3570 + diff_x_val,
          top: 221,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_水声_0
        {
          audioSrc: audioUrl + "sea/sea_2.aac",
          left: 3062 + diff_x_val,
          top: 751,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_水声_1
        {
          audioSrc: audioUrl + "sea/sea_1.aac",
          left: 3449 + diff_x_val,
          top: 781,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_水声_2
        {
          audioSrc: audioUrl + "sea/sea_2.aac",
          left: 3236 + diff_x_val,
          top: 1118,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },
        // 海边_水声_3
        {
          audioSrc: audioUrl + "sea/sea_3.aac",
          left: 3688 + diff_x_val,
          top: 1502,
          type: 3,
          sceneType: 4,
          xhrStep: 6,
        },

        //游乐场，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，
        // 游乐场_1
        {
          audioSrc: audioUrl_more + "01_01.aac",
          left: 1768 - 70 + diff_x_val,
          top: 621,
          type: 3,
          sceneType: 1,
          xhrStep: 5,
        },
        // 游乐场_2
        {
          audioSrc: audioUrl + "playground/child_1.aac",
          left: 1906 - 70 + diff_x_val,
          top: 423,
          type: 3,
          sceneType: 1,
          xhrStep: 5,
        },
        // 游乐场_3
        {
          audioSrc: audioUrl_more + "01_03.aac",
          left: 2109 - 70 + diff_x_val,
          top: 568,
          type: 3,
          sceneType: 1,
          xhrStep: 5,
        },
        // 游乐场_4
        {
          audioSrc: audioUrl_more + "01_04.aac",
          left: 2064 - 70 + diff_x_val,
          top: 227,
          type: 3,
          sceneType: 1,
          xhrStep: 5,
        },
        // 游乐场_5
        {
          audioSrc: audioUrl_more + "01_05.aac",
          left: 1760 - 70 + diff_x_val,
          top: 227,
          type: 3,
          sceneType: 1,
          xhrStep: 5,
        },
        // 森林，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，，
        // 森林_1
        {
          audioSrc: audioUrl + "forest/forest_2.aac",
          left: 566 + diff_x_val,
          top: 1091,
          type: 3,
          sceneType: 5,
          xhrStep: 2,
        },
        // 森林_2
        {
          audioSrc: audioUrl_more + "02_06.aac",
          left: 1017 + diff_x_val,
          top: 1134,
          type: 3,
          sceneType: 5,
          xhrStep: 2,
        },
        // 森林_3
        {
          audioSrc: audioUrl + "forest/forest_3.aac",
          left: 825 + diff_x_val,
          top: 1649,
          type: 3,
          sceneType: 5,
          xhrStep: 2,
        },
        // 只放停机坪音源
        {
          audioSrc: audioUrl_more + "helicopter.aac",
          left: 579,
          top: 1227,
          type: 3,
          height: 1,
          sceneType: 6,
          xhrStep: 7,
        },
        // 停机坪（直升机,曲线动画）
        {
          src: "/space/images/sound-source.svg",
          left: 579,
          top: 1227,
          type: 5,
          height: 0,
          sceneType: 6,
          xhrStep: 7,
        },
      ],
      onLoadBool: false,
    };
  },
  computed: {
    ...mapState(["isSafari"]),

    mapDataId() {
      return this.mapData.map((item, index) => {
        return {
          ...item,
          id: index,
        };
      });
    },
  },
  created() {
    this.getSafari();
  },
  mounted() {},
  destoryed() {},
  methods: {
    async initAudio() {
      try {
        this.loading = true;
        let xhrObj = {};
        this.mapData.forEach((item) => {
          if (!item.audioSrc) return;
          if (xhrObj[item.xhrStep]) {
            xhrObj[item.xhrStep].push(item.audioSrc);
          } else {
            xhrObj[item.xhrStep] = [item.audioSrc];
          }
        });
        let list = Object.keys(xhrObj).sort((a, b) => a - b);
        for (var i in list) {
          await Promise.all(this.getAudio(xhrObj[list[i]]));
          // console.log(`第${i * 1 + 1}步加载完毕`);
        }

        await this.getVirtualJs();
        // console.log("全部完毕");
        this.loading = false;
        this.onLoadBool = true;
      } catch (err) {
        this.loading = false;
        this.onLoadBool = true;
        console.log("报错了", err);
      }
    },
    getVirtualJs() {
      return new Promise(
        (resolve, reject) => {
          try {
            var xhr = new XMLHttpRequest();
            // xhr.open("GET", "/wasm/libwanos_virtual.js", true);
            xhr.open("GET", "/space/worklet/processor.js", true);
            xhr.onload = () => {
              resolve();
            };
            xhr.send();
          } catch (err) {
            console.error(err);
          }
        },
        (err) => {
          console.error(err);
          reject();
        }
      );
    },
    getAudio(list) {
      return list.map((item) => {
        return new Promise(
          (resolve, reject) => {
            try {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", item, true);
              // 设置响应类型为 arraybuffer
              xhr.responseType = "arraybuffer";
              xhr.onload = () => {
                resolve();
              };
              xhr.send();
            } catch (err) {
              console.error(err);
            }
          },
          (err) => {
            console.error(err);
            reject();
          }
        );
      });
    },

    // 浏览器判断
    ...mapMutations(["geSafari"]),
    getSafari() {
      // 浏览器判断
      let explorer = navigator.userAgent;
      if (explorer.indexOf("MSIE") >= 0) {
        //ie
        // alert("ie");
      } else if (explorer.indexOf("Firefox") >= 0) {
        //firefox
        // alert("Firefox");
        this.geSafari("Firefox");
      } else if (explorer.indexOf("Chrome") >= 0) {
        //Chrome
        // alert("Chrome");
      } else if (explorer.indexOf("Opera") >= 0) {
        //Opera
        // alert("Opera");
      } else if (explorer.indexOf("Safari") >= 0) {
        //Safari
        // alert("Safari");
        this.geSafari("Safari");
      } else if (explorer.indexOf("Netscape") >= 0) {
        //Netscape
        // alert("Netscape");
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.home {
  width: 100%;
  height: 100%;
}
.loadStyle {
  position: absolute;
  top: 53%;
  width: 100%;
  text-align: center;
  z-index: 10000;
}
.stopPos {
  position: absolute;
  z-index: 100000;
}
</style>
